<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-title>Create Payment Collect Link</v-list-item-title>
      </v-list-item>
    </template>

    <v-card>
      <ModelTitle title="Create Link" @close="dialog = false" />

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-card dark flat color="text--white">
              <v-card-title>
                <span>Copy This Link To Share</span>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn small @click="copyLink" fab v-on="on">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copy link</span>
                </v-tooltip>
                <v-tooltip bottom v-if="showShare">
                  <template v-slot:activator="{ on }">
                    <v-btn small @click="shareLink" fab v-on="on">
                      <v-icon>mdi-share</v-icon>
                    </v-btn>
                  </template>
                  <span>Copy link</span>
                </v-tooltip>
              </v-card-title>
              <v-card-text>
                <span style="color: white"> {{ url }} </span>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-col class="shrink">
                  <v-dialog v-model="whatsAppDialog" width="450">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark color="green" small v-bind="attrs" v-on="on">
                        Send WhatsApp
                      </v-btn>
                    </template>

                    <v-card>
                      <ModelTitle title="Whatsapp Message" @close="whatsAppDialog = false" />

                      <v-card-text>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field class="centered-input" type="tel" outlined dense hide-details
                              label="WhatsApp Number" v-model="cellNumber"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea dense autofocus outlined name="input-7-4" label="Message"
                              v-model="message"></v-textarea>
                          </v-col>
                        </v-row>


                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="primary" @click="sendWhatsAppMessage">
                          Send
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-col>
                <v-spacer></v-spacer>
                <v-row justify="end">
                  <v-col class="shrink">
                    <v-dialog v-model="textMessagesDialog" width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn dark color="#F0C316" small v-bind="attrs" v-on="on">
                          Send Text Message
                        </v-btn>
                      </template>

                      <v-card>
                        <ModelTitle title="Send Message" @close="textMessagesDialog = false" />

                        <v-card-text>
                          <v-text-field class="centered-input" type="tel" outlined dense hide-details autofocus
                            label="Cell Number" v-model="cellNumber"></v-text-field>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" @click="sendTextMessage">
                            Send
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- <div class="title">Copy This URL To Share</div>
        <div class="mt-3">{{ url }}</div>
        <v-btn rounded @click="copyLink" color="info">Copy</v-btn> -->
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import copy from "copy-to-clipboard";
// import Hashids from "hashids";
import { mapGetters } from "vuex";
// const hashids = new Hashids();
// import { WhatsApp } from "vue-socialmedia-share";
import customerService from '@/modules/Customer/service.js'

export default {
  props: ["id", "customer"],
  name: 'create-payment-link',
  data() {
    return {
      whatsAppDialog: false,
      cellNumber: null,
      textMessagesDialog: false,
      token: null,
      message: null,
      showShare: false,
      url: "Creating URL Please wait...",
      dialog: null
    };
  },
  // components: {
  //   WhatsApp,
  // },
  computed: {
    ...mapGetters("global", ["currentBusiness"])
  },
  watch: {
    textMessagesDialog(val) {
      if (val) {
        this.cellNumber = this.customer.fatherPhoneNumber
      }
    },
    whatsAppDialog(val) {
      if (val) {
        this.cellNumber = this.customer.fatherPhoneNumber
      }
    },
    dialog(val) {
      if (val) {
        // const hashId = hashids.encode(this.id);
        this.createToken()
        // this.url = btoa("category=textile&user=user1")
        // this.urlc = atob(this.url)
      }
    }
  },
  created() {
    if (navigator.share) {
      this.showShare = true;
    } else {
      this.showShare = false;
    }
  },
  methods: {
    sendWhatsAppMessage() {
      // <a href="$1" target="_blank">$1</a>

      // let replacedString = this.message.replace("{{link}}", `<a href="${this.url}" target="_blank">'Click Here'</a>`);
      // console.log('sendWhatsAppMessage', replacedString)


      let before = this.message.split('{{');
      let after = this.message.split('}}');
      let startIndex = this.message.indexOf("{{");
      console.log('startIndex', startIndex)
      // console.log('before', encodeURIComponent(before[0].trim()))
      // console.log('after', encodeURIComponent(after[1].trim()))
      let newValue = null

      if (startIndex != -1) {
        newValue = encodeURIComponent(before[0].trim())
        // + ' ' + this.url + ' ' + encodeURIComponent(after[1].trim())
        newValue += ' '
        // newValue += decodeURIComponent(`${process.env.VUE_APP_FE_URL}/p/${this.token}`)
        newValue += this.url
        newValue += ' '
        newValue += encodeURIComponent(after[1].trim())
        // console.log('newValue', newValue)
      } else {
        newValue = this.message
      }


      let link = `https://api.whatsapp.com/send?phone=${this.cellNumber}&text=${newValue}`

      window.open(link, "_blank");
      this.whatsAppDialog = !this.whatsAppDialog
      this.dialog = !this.dialog
    },
    sendTextMessage() {
      // console.log("send test messetes", this.cellNumber);
      const obj = {
        phoneNumber: this.cellNumber,
        url: this.url,
        customerName: this.customer.name,
      };


      customerService
        .publicSendTextMessage(obj)
        .then(() => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Messages Send! ",
            });
        });

      this.textMessagesDialog = false;
      this.dialog = false
    },
    async createToken() {
      const Customer = (await customerService.getById(this.customer.id)).data
      if (Customer && Customer.token) {
        this.token = Customer.token
        this.url = `${process.env.VUE_APP_FE_URL}/p/${this.token}`;
      } else {
        return customerService.createLink({ CustomerId: this.id })
          .then(result => {
            // console.log('token', result)
            this.token = result.data.token
            this.url = `${process.env.VUE_APP_FE_URL}/p/${this.token}`;
            // console.log('result', result)
          })
      }

    },
    shareLink() {
      if (navigator.share) {
        navigator
          .share({
            title: this.currentBusiness.name,
            text: this.text,
            url: this.url
          })
          .then(() => console.log("Successful share"))
          .catch(error => console.log("Error sharing:", error));
      }
      this.dialog = false;
    },
    copyLink() {
      copy(this.url);
      this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000
        })
        .fire({
          icon: "success",
          title: "Link is copy!"
        });

      this.dialog = false;
    }
  }
};
</script>

<style scoped></style>
